import { render, staticRenderFns } from "./RequestCollect.vue?vue&type=template&id=193f1f2c&scoped=true&"
import script from "./RequestCollect.vue?vue&type=script&lang=js&"
export * from "./RequestCollect.vue?vue&type=script&lang=js&"
import style0 from "./RequestCollect.vue?vue&type=style&index=0&id=193f1f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193f1f2c",
  null
  
)

export default component.exports